import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  readAdminCustomerRouteParam,
  readRouteParam,
} from '../../../_utils/route-param.utils';
import { TranslateModule } from '@ngx-translate/core';
import IMarketingChannels from '../../../_interfaces/IMarketingChannels';
import { AdminEntityLoaderService } from '../../../_services/admin/admin-entity-loader.service';
import { AdminFormLayoutComponent } from '../../../components/admin-ui/admin-form-layout/admin-form-layout.component';
import { AdminPageHeaderComponent } from '../../../components/admin-ui/admin-page-header/admin-page-header.component';
import { AdminStatePanelComponent } from '../../../components/admin-ui/admin-state-panel/admin-state-panel.component';
import { FormMarketingChannelComponent } from '../../../components/forms/form-marketing-channel/form-marketing-channel.component';

@Component({
  selector: 'app-admin-marketing-channel-detail',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AdminPageHeaderComponent,
    AdminStatePanelComponent,
    AdminFormLayoutComponent,
    FormMarketingChannelComponent,
  ],
  templateUrl: './admin-marketing-channel-detail.component.html',
  styleUrl: './admin-marketing-channel-detail.component.scss',
})
export class AdminMarketingChannelDetailComponent implements OnInit {
  public customersId = 0;
  public channelsId = 0;
  public channel: IMarketingChannels | null = null;
  public loading = true;
  public hasError = false;
  readonly reload = (): void => this.load();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loader: AdminEntityLoaderService,
  ) {}

  get backLink(): any[] {
    return [
      '/administration',
      readAdminCustomerRouteParam(this.route, this.customersId) || this.customersId,
      'marketing-channels',
    ];
  }

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
    this.channelsId = readRouteParam(this.route, 'channels_id');
    this.load(true);
  }

  load(fromResolver = false): void {
    this.loading = true;
    this.hasError = false;

    if (fromResolver) {
      const channel = (this.route.snapshot.data['marketingChannel'] || null) as
        | IMarketingChannels
        | null;
      if (channel) {
        this.channel = channel;
        this.loading = false;
        return;
      }
    }

    this.loader
      .loadMarketingChannel(this.customersId, this.channelsId)
      .subscribe({
        next: (channel) => {
          this.channel = channel;
          this.hasError = !channel;
          this.loading = false;
        },
        error: () => {
          this.hasError = true;
          this.loading = false;
        },
      });
  }
}
